import { render } from "./Button.ce.vue?vue&type=template&id=13807aec"
import script from "./Button.ce.vue?vue&type=script&lang=js"
export * from "./Button.ce.vue?vue&type=script&lang=js"

import _style_0 from "./Button.ce.vue?vue&type=style&index=0&id=13807aec&inline&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__